// tracking
import ReactPixel from "react-facebook-pixel";
import ReactGA from "react-ga";

export function trackPage() {
  if (window.location.hostname !== `localhost`) {
    ReactGA.pageview(window.location.pathname + window.location.search);
    ReactPixel.pageView();
  }
}

export function trackContent(page) {
  if (window.location.hostname !== `localhost`) {
    ReactPixel("track", "ViewContent", {
      content_name: page,
      referrer: document.referrer,
      userAgent: navigator.userAgent,
      language: navigator.language
    });
  }
}



// WEBPACK FOOTER //
// ./src/utils/tracking.js